<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">

      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Crear lección</h1>

      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">
              <div class="col-12">
                <b-form-group label="Título" label-for="keyInput" >
                  <b-form-input
                    id="keyInput"
                    v-model="form.title"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Categoría:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.category"
                    :options="categories"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Subcategoría:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.subcategory"
                    :options="subcategories"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Competencia:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.competencies"
                    :options="competencies"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group
                  id="input-group-3"
                  label="Dificultad:"
                  label-for="input-3"
                >
                  <b-form-select
                    id="input-3"
                    v-model="form.difficulty"
                    :options="difficulties"
                    required
                  ></b-form-select>
                </b-form-group>
              </div>

              <div class="col-6">
                <input
                  type="checkbox"
                  v-model="form.isPremium"
                  :class="{ 'checked': form.isPremium }"
                />
                <span class="span-diagnostic">Es lección premium</span>
              </div>

              <hr>

              <div class="col-12">
                <hr>
                <div class="row">
                  <div class="col-2"><MarkdownHelp/></div>
                  <div class="col-2"><ImagesBank @addImage="addImage"/></div>
                </div>

                <br>
                <b-form-group
                  id="input-group-1"
                  label="Contenido:"
                  label-for="input-1"
                  description="Vista previa con Markdown"
                >
                  <b-form-textarea
                    id="textarea"
                    v-model="form.text"
                    placeholder=""
                    rows="9"
                    max-rows="16"
                  ></b-form-textarea>
                  <hr />
                </b-form-group>

                <vue-markdown :source="form.text">
                    {{this.form.text}}
                </vue-markdown>
              </div>

            </div>
            <b-button type="submit" class="mt-3" variant="primary" >Guardar</b-button>
            <b-button type="submit" variant="primary" class="float-right mt-3" @click="goToSimulacrums">Cancelar</b-button>
          </b-form>
        </div>
      </div>
    </div>

    <!-- add practices-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Práctica Inicial (opcional)</h3>
            <button class="btn btn-primary"  @click="showModal1()" v-if="!lesson.practicesList || (lesson && lesson.practicesList && !lesson.practicesList.some(item => item.step === 1))">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Práctica Inicial
            </button>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
            <tr >
              <th>Titulo</th>
              <th>Descripcción</th>
            </tr>
            </thead>
            <tbody v-for="item in lesson.practicesList" :key="item.practices.id">
            <tr v-if="item.step === 1">
              <td>{{ item.practices.title}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                        v-on:click="deletePractice(item.practices.id)">
                  Eliminar
                </button>
              </td>
            </tr>
            </tbody>

            <tbody v-if="lesson && lesson.practicesList && lesson.practicesList.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <PracticesAdd  v-if="lesson !== [] && lessonId" ref="practicesAddComponent1" @savePractice="savePractice" :lesson-type="'1'" :lesson-id="lessonId"/>

    </div>
    <!-- /add practices-->

    <!-- add practices-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Práctica Final (opcional)</h3>
            <button class="btn btn-primary"  @click="showModal3()" v-if="!lesson.practicesList || (lesson && lesson.practicesList && !lesson.practicesList.some(item => item.step === 2))">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Práctica Final
            </button>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
            <tr >
              <th>Titulo</th>
              <th>Descripcción</th>
            </tr>
            </thead>
            <tbody v-for="item in lesson.practicesList" :key="item.practices.id">
            <tr v-if="item.step === 2">
              <td>{{ item.practices.title}}</td>
              <td>{{ item.practices.text}}</td>
              <td>
                <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                        v-on:click="deletePractice(item.practices.id)">
                  Eliminar
                </button>
              </td>
            </tr>
            </tbody>

            <tbody v-if="lesson && lesson.practicesList && lesson.practicesList.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <PracticesAdd  v-if="lesson" ref="practicesAddComponent2" @savePractice="savePractice" :lesson-type="'2'" :lesson-id="lessonId"/>

    </div>
    <!-- /add practices-->

    <!-- add Tags-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
      <div id="app" class="container mt-5">

          <div class="div-lessons">
            <h3>Tags</h3>
            <button class="btn btn-primary"  @click="showModal2()" type="button">
              <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar tags
            </button>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
            <tr >
              <th>Titulo</th>
              <th></th>

            </tr>
            </thead>
            <tbody v-for="tag in tags" :key="tag.id">
            <tr>
              <td>{{ tag.name }}</td>

              <td>
                <button class="btn btn-secondary "
                        v-on:click="deleteTag(tag.id)">
                  Eliminar
                </button>
              </td>
            </tr>
            </tbody>

            <tbody v-if="tags && tags.length === 0">
            <tr >
              <td colspan="2" class="td-nhd">No hay datos</td>
            </tr>
            </tbody>
          </table>

          <b-modal no-close-on-backdrop ref="my-modal3" size="xl" hide-footer title="Tags" v-on:hide="onModalHide">

            <div class="lessons-model">
              <b-input-group>
                <input type="text" class="form-control" placeholder="Crear o buscar tag"
                       aria-label="Search" aria-describedby="basic-addon2" v-model="searchTags"  v-on:keyup="loadTags">
                <b-input-group-append>
                  <b-button variant="info" v-on:click="createTag"
                  >Crear</b-button>
                </b-input-group-append>
              </b-input-group>

            </div>

            <div class="lessons-model">
              <table class="table">
                <thead>
                <tr>
                  <th>Nombre</th>
                  <th></th>
                </tr>
                </thead>
                <tbody v-for="(tag, index) in tagsItems" :key="index">
                <tr>
                  <td>{{ tag.name }}</td>
                  <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-danger" v-on:click="saveTag(tag.id)"
                              block>Agregar</b-button>
                  </div></td>
                </tr>
                </tbody>

                <tbody v-if="tags && tags.length === 0">
                <tr >
                  <td colspan="2" class="td-nhd">No hay datos</td>
                </tr>
                </tbody>
              </table>
            </div>

          </b-modal>

        </div>
      </div>

    </div>
    <!-- /add Tags-->
  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";
import { VueEditor } from "vue2-editor";
import PracticesAdd from "@/views/Admin/Components/Practices/PracticesAdd.vue";
import MarkdownHelp from '@/views/Admin/Components/Utils/MarkdownHelp.vue'
import VueMarkdown from 'vue-markdown'
import ImagesBank from '@/views/Admin/Components/Utils/ImagesBank.vue'
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  components: {
    PracticesAdd,
    VueEditor,
    VueMarkdown,
    MarkdownHelp,
    ImagesBank
  },
  data() {
    return {
      form: {
        title: "",
        category: null,
        subcategory: null,
        competencies: null,
        difficulty: null,
        text: "",
        isPremium: false,
      },
      newMathjax: "",
      lesson: [],
      tags: [],
      modules: [],
      modulesResponse: [],
      practiceId: null,
      show: true,
      lessonId: null,
      isEdit: false,
      inputDaterange: null,
      practicesItems: [],
      tagsItems: [],
      SearchPractices: "",
      searchTags: "",
      categories: [],
      subcategories: [],
      competencies: [],
      difficulties: [],
      categoriesResponse: [],
    };
  },
  beforeRouteLeave(to, from, next) {
  if (this.lesson.practicesList && this.lesson.practicesList.every(practice => practice.step !== 2)) {
    if (confirm('Es necesario agregar la práctica final, ¿estás seguro de que quieres salir?')) {
      next();
    } else {
      next(false);
    }
  } else {
    next();
  }
},
  methods: {
    createTag() {
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/tag/save", {
          name: this.searchTags,
          lessonId: this.lessonId,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "tag Guardado y agregado."
        );
        console.log(result);
        this.$router.go();
      }).catch((err) => {

        if(err.message === 'Request failed with status code 406') {
            this.$toastr.defaultTimeout = 5000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
            "El ya existe o ya se agregó, revisa los resultados de búsqueda"
          );
        } else {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear"
          );
        }
        console.log(err.message);
      });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {

      var formData = new FormData();
      formData.append("image", file);

      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/lessons/UploadImage", formData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then(result => {
          const url = result.data; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
    },
    populateSelectSubcategories() {
      this.subcategories = [];
      if (this.form.category) {
        let relatedCategories = this.categoriesResponse.find(obj => obj.id === this.form.category).subcategoryList;
        this.subcategories.push({text: 'Selecciona una subcategoría', value: null})

        for (let item of relatedCategories) {
          if(item.deleted) {
            continue;
          }
          this.subcategories.push({text: item.description, value: item.id})
        }
      }
    },
    loadSubcategory() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/subcategory/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.subcategories.push({
            text: "Selecciona una subcategoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.subcategories.push({ text: item.description, value: item.id });
          }

          this.loadKnowledge();
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    loadCategories() {
      let loader = this.$loading.show({});
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/categories/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.categoriesResponse = arr
          this.categories.push({
            text: "Selecciona una categoría",
            value: null,
          });
          for (let item of arr) {
            if (item.deleted) {
              continue;
            }
            this.categories.push({ text: item.description, value: item.id });
          }

          this.loadCompetences();
          loader.hide();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    async loadCompetences() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/competences/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.competencies.push({
            text: "Selecciona una competencia",
            value: null,
          });
          for (let item of arr) {
            this.competencies.push({ text: item.description, value: item.id });
          }

          this.callEditService();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    async loadDifficulty() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/difficulty/list", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let arr = response.data;
          this.difficulties.push({
            text: "Selecciona una dificultad",
            value: null,
          });


          for (let item of arr.sort((a, b) => a.id - b.id)) {
            this.difficulties.push({ text: item.description, value: item.id });
          }

          this.loadCategories();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    goToSimulacrums() {
      this.$router.push(`/admin-panel/lecciones`);
    },
    onModalHide() {
      this.practicesItems = [];
      this.tagsItems = [];
    },
    onSubmit(event) {
      event.preventDefault();
      let loader = this.$loading.show({});

      this.form.isPremium = this.form.isPremium === true || this.form.isPremium === 'true';

      if (this.form.endDate == "" || this.form.startDate == ""){
        alert("por favor ingrese un rango de fecha");
        loader.hide();
      } else {
        if (this.isEdit) {
        axios
          .put(
            import.meta.env.VITE_API_BASE_URL + "/api/lessons/edit/" + this.lessonId, this.form, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("lección Editada.");
            console.log(result);
            loader.hide();
            router.push({ path: `/admin-panel/lecciones` });
          }).catch((err) => {
            if (err.response.data.response === 'duplicated') {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Ya se ha creado una lección con este nombre"
              );
              console.log(err.message);
              loader.hide();
            } else {
              this.$toastr.defaultTimeout = 2000; // default timeout : 5000
              this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
              this.$toastr.e(
                "Error al editar"
              );
              console.log(err.message);
              loader.hide();
            }
          });
      } else {
        axios
          .post(
            import.meta.env.VITE_API_BASE_URL + "/api/lessons/save",this.form,{
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then((result) => {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.s("lección Guardada.");
            console.log(result);
            loader.hide();
            router.push({ path: `/admin-panel/lecciones` });
          }).catch((err) => {
          if (err.response.data.response === 'duplicated') {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Ya se ha creado una lección con este nombre"
            );
            console.log(err.message);
            loader.hide();
          } else {
            this.$toastr.defaultTimeout = 2000; // default timeout : 5000
            this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
            this.$toastr.e(
              "Error al crear"
            );
            console.log(err.message);
            loader.hide();
          }
        });
        }
      }
    },
    deletePractice(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta práctica?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/lessons/" + this.lessonId + "/practices/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    deleteTag(id) {
      if(!confirm("¿Estás seguro que deseas eliminar este tag?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/lessons/" + this.lessonId + "/tag/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    savePractice(data) {
      const practiceId = data.questionId;
      const type = data.type;

      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/lessons/savePractice", {
        'lessonId': moduleId  , 'practiceId': practiceId, "type": type
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Práctica Guardada."
        );
        console.log(result);
        this.$router.go();
      }).catch((err) => {

        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e(
          "Error al crear"
        );
        console.log(err.message);

      });
    },
    saveTag(tagId) {

      this.moduleId = this.$route.params.id;
      var moduleId = parseInt(this.moduleId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/lessons/saveTag", {
        'lessonsId': moduleId  , 'tagId': tagId
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Tag Guardado."
        );
        console.log(result);
        this.$router.go();
      }).catch((err) => {

        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.e(
          "Error al crear"
        );
        console.log(err.message);

      });
    },

    showModal1() {
      this.$refs['practicesAddComponent1'].showModal();
    },
    showModal2() {
      this.$refs['my-modal3'].show();
    },
    showModal3() {
      this.$refs['practicesAddComponent2'].showModal();
    },
    onReset(event) {
      event.preventDefault();
    },
    addImage(image){
      this.form.text = this.form.text.concat("\n!" +
        "[id]" +
        "\n\n" +
        "[id]: " +  'https://mobius-imgs.s3.amazonaws.com/' + image.replace('svg+xml', 'svg%2Bxml') +  " \"landscape\" \n")
    },
    loadTags() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/tag/getTagsListforAdd/" + this.lessonId, {
          params: {
            search: this.searchTags,
            modelName: "lessons",
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.tagsItems = response.data;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    callEditService() {
      if (this.$route.params.id) {
        let loader = this.$loading.show({});
        this.lessonId = this.$route.params.id;
        this.isEdit = true;
        axios
          .get(
            import.meta.env.VITE_API_BASE_URL + "/api/lessons/" + this.lessonId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            this.form.text = response.data.text;
            this.form.title = response.data.title;
            this.form.difficulty = response.data.difficulty ? response.data.difficulty.id : "";
            this.form.category = response.data.subCategory.category.id;
            this.form.subcategory = response.data.subCategory.id;
            this.form.competencies = response.data.competence.id;
            this.form.isPremium = response.data.isPremium;

            this.subcategories.push({text: 'Selecciona una subcategoría', value: null})

            if (this.categoriesResponse) {
              for (let cat of this.categoriesResponse) {
                if (cat.subcategoryList) {
                  for (let subcat of cat.subcategoryList) {
                    if (subcat.id === this.form.subcategory) {
                      this.form.category = cat.id;
                      this.subcategories.push({text: 'Selecciona una subcategoría', value: null})
                      for (let item of cat.subcategoryList) {
                        if (item.deleted) {
                          continue;
                        }
                        this.subcategories.push({text: item.description, value: item.id})
                      }
                      this.form.subcategory = subcat.id;
                    }
                  }
                }

              }
            }

            if(response.data === '') {
              this.lesson = [];
              this.simulacrumsModule = [];

              return;
            }
            let data = response.data;
            this.tags = data.tags;

            this.lesson = data;
            this.simulacrumsModule = data;
            loader.hide();
          }).catch((err) => {
          console.log(err.message);
          loader.hide();
        });
      }

    }
  },
  watch: {

    'form.text': function () {

      if ("MathJax" in window) {
        this.$nextTick(function () {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    'form.category'() {
      if (this.isEdit == true) {
        if (this.lesson.practicesList && this.lesson.practicesList.every(practice => practice.step !== 2)) {
          this.$toastr.s(
            "Es necesario agregar la práctica final."
          );
        }
      }
      this.populateSelectSubcategories();
    },
  },
  mounted() {
    this.loadDifficulty();
  },
  beforeMount() {

    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

    window.MathJax.Hub.Config({
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"],
        ],
      },
    });
  },
};
</script>
